import { useEffect, useState } from 'react'
/**
 * @return{svg} animated line
 */
function AnimatedLine({}) {
  const [elementclientHeight, setElementclientHeight] = useState('')
  const [elementscrollHeight, setElementscrollHeight] = useState('')
  const [bodyscrollTop, setBodyscrollTop] = useState('')
  const [elementscrollTop, setElementscrollTop] = useState('')
  const pathLength = '1000'

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  })

  const handleScroll = () => {
    setElementclientHeight(document.documentElement.clientHeight.toString())
    setElementscrollHeight(document.documentElement.scrollHeight.toString())
    setBodyscrollTop(document.body.scrollTop.toString())
    setElementscrollTop(document.documentElement.scrollTop.toString())
  }

  const scrollPercentage =
    (parseInt(elementscrollTop) + parseInt(bodyscrollTop)) /
    (parseInt(elementscrollHeight) - parseInt(elementclientHeight))
  let drawLength = 0
  if (scrollPercentage >= 0) {
    drawLength = parseInt(pathLength) * scrollPercentage
  }
  const strokeDashOffset = parseInt(pathLength) - drawLength

  return (
    <div className="fixed top-0 left-0 w-full h-full overflow-hidden text-center pointer-events-none">
      <svg
        className="relative inline-block h-full z-[5]"
        preserveAspectRatio="xMidYMax meet"
        viewBox="0 0 533 3995"
        fill="none"
      >
        <path
          className="stroke-animatedline"
          d="M 331.001 0 C 331.001 562 331.001 727.833 331.001 740.5 V 821 V 871 V 902.5 V 920 V 950.5 V 977 C 331.001 977 352.5 1011.5 331.001 1030.5 C 309.502 1049.5 138 1189 331.001 1252.5 C 524.002 1316 664.502 1533 331.001 1514 C -2.49963 1495 593.502 1902 331.001 2150 C 68.5004 2398 535.001 2240 456 2386.5 C 376.999 2533 -72.9999 2416.5 11.0001 2562.5 C 95.0001 2708.5 286.002 2822 331.001 2877 C 376 2932 343.5 3108 331.001 3170 C 318.502 3232 331.001 3471.5 331.001 3471.5 V 3702 V 3994.5"
          strokeWidth="7"
          strokeDashoffset={strokeDashOffset + ''}
          strokeDasharray={parseInt(pathLength) + ' ' + parseInt(pathLength)}
          pathLength="1000"
        />
      </svg>
    </div>
  )
}
export default AnimatedLine
